import {WINDOW} from '../constants/environment'
import {history, getLocation} from './history'

export const getHash = () => getLocation().hash.slice(1)

export const updateHash = (hash, affectHistory) => {
  if (!WINDOW) return
  // Keep search params when pushing hash
  const {search} = getLocation()
  if (affectHistory) {
    history.push({search, hash})
  } else {
    history.replace({search, hash})
  }
}

// remove hash in url without affecting history or forcing reload
export const removeHash = () => {
  if (!WINDOW) return
  // Keep search params when pushing hash
  const {search} = getLocation()
  if (getHash().length) {
    history.replace({search, hash: ''})
  }
}



// WEBPACK FOOTER //
// ./src/utils/hash.js